import React from 'react';
import { Megaphone, Copy, Check } from 'lucide-react';
import { toast } from 'sonner';
import { useT } from '@/lib/i18n';

const CTAList = ({ ctas = [] }) => {
  const { lang } = useT();
  const [copiedIdx, setCopiedIdx] = React.useState(null);
  const copy = async (txt, idx) => {
    try {
      await navigator.clipboard.writeText(txt);
      setCopiedIdx(idx);
      toast.success(lang === 'fr' ? 'CTA copié' : 'CTA copied');
      setTimeout(() => setCopiedIdx(null), 1500);
    } catch { toast.error('Copy failed'); }
  };
  return (
    <div className="rounded-xl border border-white/10 bg-[#0a0a0a] p-4" data-testid="cta-list">
      <div className="flex items-center gap-2 mb-3">
        <Megaphone className="w-3.5 h-3.5 text-[#D4FF00]" />
        <span className="font-heading font-bold text-xs sm:text-sm uppercase tracking-wider">
          {lang === 'fr' ? 'CTA prêts à l\'emploi' : 'Ready-to-use CTAs'}
        </span>
      </div>
      <div className="space-y-2">
        {ctas.length === 0 ? (
          <span className="text-zinc-600 text-sm italic">—</span>
        ) : ctas.map((cta, idx) => (
          <div
            key={`${cta}-${idx}`}
            className="flex items-center justify-between gap-3 px-3 py-2.5 rounded-lg border border-white/5 bg-white/[0.02] hover:border-[#D4FF00]/30 transition-colors group"
            data-testid={`cta-item-${idx}`}
          >
            <p className="text-sm text-zinc-300 group-hover:text-white transition-colors min-w-0 flex-1 truncate">{cta}</p>
            <button
              onClick={() => copy(cta, idx)}
              className="p-1.5 rounded-md hover:bg-white/10 text-zinc-400 hover:text-white transition-colors shrink-0"
              data-testid={`cta-copy-${idx}`}
              title="Copy"
            >
              {copiedIdx === idx ? <Check className="w-3.5 h-3.5 text-[#D4FF00]" /> : <Copy className="w-3.5 h-3.5" />}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CTAList;
